import React, { Component } from 'react';
//import moment from 'moment';
import { Link } from 'react-router-dom';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class TradeTypesTable extends Component {
  columns = [
    {
      path: 'name',
      label: 'Name',
    },
    // {
    //   path: 'created_at',
    //   label: 'Created Date',
    //   content: ttype =>
    //     moment(ttype.created_at)
    //       .startOf('day')
    //       .format('LL')
    // },
    {
      key: (ttype) => `${ttype._id}-s`,
      label: 'Info',
      content: (ttype) => (
        <Link
          to={`/trade-types/${ttype._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: 'delete',
    label: 'Delete',
    content: (ttype) => (
      <button
        onClick={() => this.props.onDelete(ttype)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: (ttype) => (
      <Link
        to={`/trade-types/edit/${ttype._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      this.columns.push(this.editColumn);
      this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { ttypes, message } = this.props;
    return <Table columns={this.columns} data={ttypes} message={message} />;
  }
}

export default TradeTypesTable;
